import { observable, action, decorate, configure, toJS } from 'mobx';
import {
  API_PRODUCTS_GET_BYAUCTION_ENDPOINT,
  API_PRODUCTS_GET_BYLANE_ENDPOINT,
} from '../shared/constants';
import { loadData } from './utils';
configure({ enforceActions: 'always' });

class ProductsStore {
  constructor() {
    this.initializeProductsList();
  }

  initializeProductsList = () => {
    this.data = [];
    this.totalItems = 0;
    this.isLoading = true;
  };

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  processData = (res) => {
    const {
      data: {
        pagedProducts: { items, totalItems },
      },
    } = res;
    this.data = toJS(items);
    this.totalItems = totalItems;
    this.isLoading = false;
  };

  loadProductsByAuction = (
    auctionID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
    mediaGalleryState,
  ) => {
    if (!auctionID) {
      return;
    }

    const params = {
      auctionID,
      pageSize,
      pageNumber,
      sortBy: sortColumn,
      sortDirection,
      mediaGalleryState,
      searchParams: searchText,
    };
    console.log('params', params);
    this.isLoading = true;
    loadData(params, API_PRODUCTS_GET_BYAUCTION_ENDPOINT).then((res) =>
      this.processData(res),
    );
  };

  loadProductsByLane = (
    laneID,
    pageNumber,
    pageSize,
    searchText,
    sortColumn,
    sortDirection,
    mediaGalleryState,
    searchParams,
  ) => {
    if (!laneID) {
      return;
    }
    const params = {
      laneID,
      pageSize,
      pageNumber,
      sortBy: sortColumn,
      sortDirection,
      mediaGalleryState,
      searchParams: searchText,
    };

    this.isLoading = true;
    loadData(params, API_PRODUCTS_GET_BYLANE_ENDPOINT).then((res) =>
      this.processData(res),
    );
  };
}

decorate(ProductsStore, {
  getProperty: action,
  initializeProductsList: action,
  isLoading: observable,
  loadProductsByAuction: action,
  loadProductsByLane: action,
  processData: action,
  data: observable,
  setData: action,
  setProperty: action,
  totalItems: observable,
});

export default ProductsStore;
